var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('img',{attrs:{"src":_vm.company_image_url,"alt":"logo"}}),_c('p',{staticClass:"label"},[_vm._v("Nom de la salle")]),_c('h1',[_vm._v(_vm._s(_vm.roomName))])])}
var staticRenderFns = []

export { render, staticRenderFns }